module.exports = __webpack_public_path__ + "media/images/webpage/hotels/9494/facility-e75e32f84c1822f1cf93811da584ffe0.webp";